<script lang="ts">
    import type {FieldTypeId, Fond, UUID} from 'typings/portaro.be.types';
    import type {Readable} from 'svelte/store';
    import type {Table} from '@tanstack/svelte-table';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import type {SvelteComponentConstructor} from 'core/types';
    import type {FondFieldTypeDefinitions} from 'src/features/record/field-types/types';
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchToolbar from 'src/features/search/kp-search-toolbar/KpSearchToolbar.svelte';
    import KpRecordGridDisplay from 'src/features/record-grid/KpRecordGridDisplay.svelte';

    export let hierarchyFieldTypeId: FieldTypeId | null;
    export let relatedFonds: Fond[] | null;
    export let includeAddNewRow: boolean;
    export let includeToolbar: boolean;
    export let inFullscreenPage: boolean;
    export let expandedFirstLevel: boolean;
    export let stickyHeader: boolean;
    export let searchType: 'record-name' | 'query';
    export let relatedRecordId: UUID | null;
    export let fond: Fond;
    export let fieldTypeDefinitions: FondFieldTypeDefinitions;
    export let insertableFonds: Fond[];
    export let controlCellComponent: SvelteComponentConstructor;

    let table$: Readable<Table<RecordRow>> | undefined;
</script>

<div class="kp-record-grid-container">
    {#if includeToolbar}
        <KpSearchToolbar {relatedFonds}
                         {fond}
                         {table$}
                         {searchType}
                         {inFullscreenPage}
                         on:fond-change/>
    {/if}

    <KpRecordGridDisplay {hierarchyFieldTypeId}
                         {fond}
                         {fieldTypeDefinitions}
                         {insertableFonds}
                         {includeAddNewRow}
                         {expandedFirstLevel}
                         {controlCellComponent}
                         {stickyHeader}
                         bind:table$
                         on:row-published
                         on:rows-updated
                         on:row-deleted
                         relatedRecordId="{exists(relatedRecordId) ? relatedRecordId : undefined}">
    </KpRecordGridDisplay>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-record-grid-container {
        display: flex;
        flex-direction: column;
        gap: @spacing-ml;
    }
</style>